import {createApp} from "petite-vue";

import.meta.glob([ '@images/**' ])
import "@styles/main.sass"
import Lenis from 'lenis'
import { gsap } from "gsap";
import CustomEase from "gsap/CustomEase";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import intro from "./animations/intro";
import quote from "./animations/quote";
import services from "./animations/services";
import claim from "./animations/claim";
import about from "./animations/about";
import team from "./animations/team";
import contact from "./animations/contact";
import marquee from "./animations/marquee";

(() => {
    const lenis = new Lenis()
    const raf = (time: number) => {
        lenis.raf(time)
        requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)
    gsap.registerPlugin(CustomEase, ScrollTrigger)

    CustomEase.create("cubic", "0.83, 0, 0.17, 1")

    lenis.on('scroll', ScrollTrigger.update)
    gsap.ticker.add((time) => {
        lenis.raf(time * 1000)
    })

    lenis.stop()
    window.lenis = lenis

    gsap.ticker.lagSmoothing(0)

    document.querySelectorAll('header a[href]').forEach(a => {
        const href = a.getAttribute('href').replace('/en/', '').replace('/#', '#')
        href.startsWith('#') && href.length > 1 && document.querySelector(href)
            && a.addEventListener('click', e => {
                e.preventDefault()
                lenis.scrollTo(href)
            })
    })

    const afterIntro = () => {
        lenis.start()

        quote()
        services()
        claim()
        about()
        team()
        contact()
        marquee()

        document.querySelectorAll('.Button').forEach(btn => {
            btn.addEventListener("mousemove", (e: MouseEvent) => {
                const boundingRect = btn.getBoundingClientRect()
                const mousePosX = e.x - boundingRect.left,
                    mousePosY = e.y - boundingRect.top

                gsap.to(btn, {
                    x: (mousePosX - boundingRect.width / 2) * 0.24,
                    y: (mousePosY - boundingRect.height / 2) * 0.24,
                    duration: 0.8,
                    ease: 'power3.out'
                })
            })

            btn.addEventListener('mouseleave', () => gsap.to(btn, { x: 0, y: 0, duration: 0.8, ease: 'elastic.out(1,0.3)' }))
        })
    }

    intro(afterIntro)
})();

